/**
 * The commit the running bundle was built from, baked in at build time.
 *
 * Reported with every piece of in-app feedback: without it we end up
 * debugging against a version the reporter was never running. See
 * `vite.config.mts` for how the value is sourced (`VITE_BUILD_SHA`, falling
 * back to Actions' `GITHUB_SHA`).
 *
 * `unknown` means the bundle was produced by a toolchain that doesn't load
 * the app's vite config — a Storybook build, say — not that the injection
 * broke in CI.
 */
export const BUILD_SHA: string = import.meta.env.VITE_BUILD_SHA ?? 'unknown'
